module.exports = __webpack_public_path__ + "static/media/car_logo_meet_matt.aaba2b88.png";